module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/215-falkland-islands-50ed78e8e634eea71423dded5a4b0025.svg";